/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { NameplateType, HeadingAlignType, ColorType, ImageSizeType } from '..';
import { themeToken } from '../../utils/cpds-utils';
import { color, mediaQueries, cpdsMediaQueryVals } from '../../token/shared/common';
/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

*/

const CpdsMagazineNameplateStyleTag = styled.div`
  min-height: 154px;
  display: flex;
  align-items: center;
  justify-content: 'space-between';
  padding: 7px 170px;
  width: 100%;
  margin: 0 auto;
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    switch (props.colorType) {
      case ColorType.PRIMARY:
        return css`
          background-color: ${token?.magazine_nameplate_standard_primary_color || color.cpds_neutral_0};
        `;
      case ColorType.SECONDARY:
        return css`
          background-color: ${token?.magazine_nameplate_standard_secondary_color || color.cpds_cream_100};
        `;
      case ColorType.TERTIARY:
        return css`
          background-color: ${props.nameplateType === NameplateType.PARTNERSHIP
            ? token?.magazine_nameplate_partnership_tertiary_color
            : token?.magazine_nameplate_standard_tertiary_color};
        `;
      default:
        return css`
          background-color: ${token?.magazine_nameplate_standard_primary_color || color.cpds_lemon_500};
        `;
    }
  }}
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      max-width: ${token?.v3_parent_grid_max_width};
    `;
  }}
 
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit}) {
    padding: 7px 24px;
  }
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
    min-height: 100%;
    padding: 32px 16px 37px;
    flex-direction: column;
    ${(props) => {
      switch (props.headingAlignType) {
        case HeadingAlignType.LEFT:
          return css`
            align-items: flex-start;
          `;
        case HeadingAlignType.CENTER:
          return css`
            align-items: center;
          `;
        default:
          return css`
            align-items: flex-start;
          `;
      }
    }}
  }
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
    padding: 32px 16px 37px;
  }
  ${(props) => props?.styleOverrides}
`;

const CpdsMagazineNameplateTitle = styled.h1`
  ${(props) => {
    switch (props.headingAlignType) {
      case HeadingAlignType.LEFT:
        return css`
          text-align: left;
        `;
      case HeadingAlignType.CENTER:
        return css`
          text-align: center;
        `;
      default:
        return css`
          text-align: left;
        `;
    }
  }}
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    switch (props.colorType) {
      case ColorType.PRIMARY:
        return css`
          color: ${token?.magazine_nameplate_standard_primary_heading_color || color.cpds_neutral_900};
        `;
      case ColorType.SECONDARY:
        return css`
          color: ${token?.magazine_nameplate_standard_secondary_heading_color || color.cpds_neutral_900};
        `;
      case ColorType.TERTIARY:
        return css`
          color: ${props.nameplateType === NameplateType.PARTNERSHIP
            ? token?.magazine_nameplate_partnership_tertiary_heading_color
            : token?.magazine_nameplate_standard_tertiary_heading_color};
        `;
      default:
        return css`
          color: ${color.cpds_neutral_900};
        `;
    }
  }}
  padding-right: 10px;
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit}) and (min-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
    font-size: 54px !important;
  }
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit}) {
    padding-right: 0;
  }
  ${(props) => props?.styleOverrides}
`;

const CpdsMagazineNameplateHeading = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 16px;
  ${(props) => {
    switch (props.headingAlignType) {
      case HeadingAlignType.LEFT:
        return css`
          justify-content: flex-start;
        `;
      case HeadingAlignType.CENTER:
        return css`
          justify-content: center;
        `;
      default:
        return css`
          justify-content: flex-start;
        `;
    }
  }}
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
    flex: 0;
    gap: 6px;
    flex-direction: column;
    ${(props) => {
      switch (props.headingAlignType) {
        case HeadingAlignType.LEFT:
          return css`
            align-items: flex-start;
          `;
        case HeadingAlignType.CENTER:
          return css`
            align-items: center;
          `;
        default:
          return css`
            align-items: flex-start;
          `;
      }
    }}
  }
  ${(props) => props?.styleOverrides}
`;

const CpdsMagazineNameplateDescription = styled.div`
  ${(props) => {
    switch (props.headingAlignType) {
      case HeadingAlignType.LEFT:
        return css`
          display: block;
        `;
      case HeadingAlignType.CENTER:
        return css`
          display: none;
        `;
      default:
        return css`
          display: block;
        `;
    }
  }}
  max-width: 302px;
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
    padding-top: 7px;
  }
  @media (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
    padding-top: 12px;
  }
  ${(props) => props?.styleOverrides};
`;

const CpdsMagazineNameplateContent = styled.p`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    switch (props.colorType) {
      case ColorType.PRIMARY:
        return css`
          color: ${token?.magazine_nameplate_standard_primary_content_color || color.cpds_neutral_900};
        `;
      case ColorType.SECONDARY:
        return css`
          color: ${token?.magazine_nameplate_standard_secondary_content_color || color.cpds_neutral_900};
        `;
      case ColorType.TERTIARY:
        return css`
          color: ${props.nameplateType === NameplateType.PARTNERSHIP
            ? token?.magazine_nameplate_partnership_tertiary_content_color
            : token?.magazine_nameplate_standard_tertiary_content_color};
        `;
      default:
        return css`
          color: ${token?.magazine_nameplate_standard_primary_content_color || color.cpds_neutral_900};
        `;
    }
  }}
  ${(props) => props?.styleOverrides}
`;

const CpdsMagazineNameplateLogoContainer = styled.div`
  --desktop-large-width: 188px;
  --desktop-large-height: 140px;
  --mobile-large-width: 114px;
  --mobile-large-height: 86px;
  --desktop-small-width: 80px;
  --desktop-small-height: 80px;
  --mobile-small-width: 48px;
  --mobile-small-height: 48px;
  ${(props) => {
    switch (props?.image?.size) {
      case ImageSizeType.LARGE:
        return css`
          width: var(--desktop-large-width);
          height: var(--desktop-large-height);
          @media (max-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
            width: ${props.imageOnly ? 'var(--desktop-large-width)' : 'var(--mobile-large-width)'};
            height: ${props.imageOnly ? 'var(--desktop-large-height)' : 'var(--mobile-large-height)'};
          }
        `;
      case ImageSizeType.SMALL:
        return css`
          width: var(--desktop-small-width);
          height: var(--desktop-small-height);
          @media (max-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
            width: ${props.imageOnly ? 'var(--desktop-small-width)' : 'var(--mobile-small-width)'};
            height: ${props.imageOnly ? 'var(--desktop-small-height)' : 'var(--mobile-small-height)'};
          }
        `;
      default:
        return css`
          width: var(--desktop-small-width);
          height: var(--desktop-small-height);
          @media (max-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
            width: ${props.imageOnly ? 'var(--desktop-small-width)' : 'var(--mobile-small-width)'};
            height: ${props.imageOnly ? 'var(--desktop-small-height)' : 'var(--mobile-small-height)'};
          }
        `;
    }
  }}
  ${(props) => props?.styleOverrides}
`;

const CpdsMagazineNameplateLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  ${(props) => props?.styleOverrides}
`;

export {
  CpdsMagazineNameplateStyleTag,
  CpdsMagazineNameplateTitle,
  CpdsMagazineNameplateHeading,
  CpdsMagazineNameplateContent,
  CpdsMagazineNameplateDescription,
  CpdsMagazineNameplateLogo,
  CpdsMagazineNameplateLogoContainer,
};
